import { Record } from 'immutable'
import { OPEN_MENU, CLOSE_MENU } from './constants'

const StateRecord = Record({
    menuOpened: false,
})

const defaultState = new StateRecord()

const reducer = (state = defaultState, { type, payload }) => {
    switch (type) {
        case OPEN_MENU:
            return state
                .set('menuOpened', true)

        case CLOSE_MENU:
            return state
                .set('menuOpened', false)

        default:
            return state
    }
}

export default reducer
